import { render, staticRenderFns } from "./TwEditAttachedFilesSection.vue?vue&type=template&id=4186b818&scoped=true&"
import script from "./TwEditAttachedFilesSection.vue?vue&type=script&lang=js&"
export * from "./TwEditAttachedFilesSection.vue?vue&type=script&lang=js&"
import style0 from "./TwEditAttachedFilesSection.vue?vue&type=style&index=0&id=4186b818&lang=scss&scoped=true&"
import style1 from "./TwEditAttachedFilesSection.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4186b818",
  null
  
)

export default component.exports